import _typeof from 'babel-runtime/helpers/typeof';
export var getValue = function getValue(item) {
  return (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' ? item.value : item;
};

export var getKey = function getKey(item) {
  return (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' ? item.key : item;
};

export var getInlineDesc = function getInlineDesc(item) {
  return (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' ? item.inlineDesc : '';
};

export var getLabel = function getLabel() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var value = arguments[1];

  if (!list.length) {
    return value;
  }
  if (typeof list[0] === 'string') {
    return value;
  }
  var match = list.filter(function (one) {
    return one.key === value;
  });
  if (match.length) {
    return match[0].value || match[0].label;
  }
  return value;
};

export var getLabels = function getLabels() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return values.map(function (value) {
    return getLabel(list, value);
  });
};


// WEBPACK FOOTER //
// ./node_modules/vux/src/components/checklist/object-filter.js